/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=79c63be1&scoped=true"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"
import style0 from "./announcements.vue?vue&type=style&index=0&id=79c63be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c63be1",
  null
  
)

export default component.exports